export default class ProductCategoryModel {
	constructor(data = {}) {
		this.id = data.id;
		this.name = data.name || null;
		this.code = data.code || null;
		this.business_company_id = data.business_company_id || null;
		this.root_product_category_id = data.root_product_category_id || null;
	}
}
